module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notScored":"Not scored","bankCheck":"Bank statement checked","scoreBtn":"Score"},"et":{"notScored":"Not scored","bankCheck":"Bank statement checked","scoreBtn":"Score"},"ru":{"notScored":"Not scored","bankCheck":"Bank statement checked","scoreBtn":"Score"}}')
  delete Component.options._Ctor
}
